export {default as BeWizrUserDocument} from './BeWizrUserDocument'